import React from "react";
import "./How_Bespoke_Gifting_Works.css";
import How_Bespoke_Gifting_Works_card from "./how_Bespoke_Gifting_Works_card/How_Bespoke_Gifting_Works_card";

function How_Bespoke_Gifting_Works() {
  const cardsData = [
    {
      number: "01",
      title: "Share Your Requirement",
      desc:
        "Tell us the occasion, recipient, and budget, we’ll take it from there.",
    },
    {
      number: "02",
      title: "Get Curated Options",
      desc:
        "Our team designs personalised gifting concepts tailored to your theme and preferences.",
    },
    {
      number: "03",
      title: "Personalise Your Gift",
      desc:
        "Add custom touches names, logos, messages, colors, or packaging style.",
    },
    {
      number: "04",
      title: "Approve the Design",
      desc: "Review digital mock-ups before we begin production.",
    },
    {
      number: "05",
      title: "We Create & Deliver",
      desc:
        "Sit back while we handcraft, package beautifully, & deliver your bespoke gift.",
    },
  ];

  return (
    <>
      <section className="How_Bespoke_Gifting_Works">
        <div className="custom_container">
          <div className="heading_holder">
            <h1>How Bespoke Gifting Works</h1>
            <h3>Design. Personalise. Delight.</h3>
          </div>

          <div className="cards_holder">
            {cardsData.map((item, index) => (
              <How_Bespoke_Gifting_Works_card
                key={index}
                number={item.number}
                title={item.title}
                desc={item.desc}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default How_Bespoke_Gifting_Works;
